import { AdvanceScreensContent, Query } from '@varo/graphql-schema-types';
import AdvanceScreenContent from 'services/graphql/queries/advance/AdvanceScreenContent';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface AdvanceScreenContentResult {
  result: AdvanceScreensContent | null;
  errorModel?: {
    screenType: ErrorScreenType;
    messageHeadline: string;
    messageBody: string;
    buttons: {
      primaryButton: {
        title: string;
        onPress: () => void;
      };
    };
  } | null;
  loading: boolean;
  refetch: () => void;
}

const useGetAdvanceScreenContent = (): AdvanceScreenContentResult => {
  const [{ data, fetching, error }, refetch] = useQuery<Query>({
    query: AdvanceScreenContent,
  });

  const advanceScreenContentData = data?.advanceScreensContent ?? null;

  const { defaultTitle, defaultMessage, retryButtonTitle } =
    useDefaultErrorStrings();

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: defaultMessage,
        buttons: {
          primaryButton: {
            title: retryButtonTitle,
            onPress: () => {
              void refetch();
            },
          },
        },
      }
    : null;

  return {
    result: advanceScreenContentData,
    loading: fetching,
    errorModel,
    refetch,
  };
};

export default useGetAdvanceScreenContent;
